import { render } from "./ReturnToCommonStockModal.vue?vue&type=template&id=58b46039&scoped=true"
import script from "./ReturnToCommonStockModal.vue?vue&type=script&lang=js"
export * from "./ReturnToCommonStockModal.vue?vue&type=script&lang=js"

import "./ReturnToCommonStockModal.vue?vue&type=style&index=0&id=58b46039&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58b46039"]])

export default __exports__